import {
    ActionsCreators,
    connectToJava
} from "../../../../../../libs/java-react-connector/dist";
import ScoreCenter from "../../components/ScoreCenter";

const PITCH_ANIMATION_STREAM = "PitchAnimationStream";
const actionsCreators: ActionsCreators<{}> = {};

interface Props {
    scoreCenterData: any;
    lang: string;
}

const event = {
    bettingAvailable: true,
    cornerKicks: null,
    date: null,
    ended: false,
    eventPointList: [],
    fouls: null,
    goalKicks: null,
    halftimeScore: null,
    navToDetails: true,
    offsides: null,
    pointScore: null,
    redCards: null,
    section: 1,
    showStats: true,
    team1: null,
    team2: null,
    topMatch: false,
    yellowCards: null
};
const scoreCenterData = {
    betGeniusId: 5976778,
    event,
    live: true,
    sportId: "soccer"
};

const INITIAL_STATE: Props = {
    lang: "de-de",
    scoreCenterData
};

export default connectToJava({
    actionsCreators,
    state: {
        [PITCH_ANIMATION_STREAM]: INITIAL_STATE
    },
    stateMapper: ({ PitchAnimationStream: { ...state } }) => ({
        ...state
    })
})(ScoreCenter);
